# USER NOTIFICATION/PERMISSION OPTIONS (DESKTOP & MOBILE)
$( ->
  $(document).on 'click', '.js-toggle-notification-options', ->
    $(this).addClass('in')
    options = $($(this).closest('.job-permission')).find('.js-advanced-notification-options')
    $(options).addClass('in')
    $(options).find('.js-notifications-content').addClass('in')
    return false

  $(document).on 'click', '.js-toggle-notification-options.in', ->
    $(this).removeClass('in')
    options = $($(this).closest('.job-permission')).find('.js-advanced-notification-options')
    $(options).removeClass('in')
    $(options).find('.js-notifications-content').removeClass('in')
    return false

  $(document).on 'click', '.js-toggle-notification-options.desktop', ->
    $(this).text('Hide Advanced Options')
    return false

  $(document).on 'click', '.js-toggle-notification-options.desktop.in', ->
    $(this).text('Show Advanced Options')
    return false

  $(document).on 'click', '.more-opts', ->
    $(this).find('.fa-angle-down').replaceWith('<i class="fa fa-2x fa-angle-up pull-right"></i>')
    $(this).addClass('in')

  $(document).on 'click', '.more-opts.in', ->
    $(this).find('.fa-angle-up').replaceWith('<i class="fa fa-2x fa-angle-down pull-right"></i>')
    $(this).removeClass('in')

  $(document).on 'click', '.expand-trigger', ->
    $(this).closest('.expand-action').find('.expand-panel').toggleClass('in')
    $(this).closest('.expand-action').find('.expand-panel-mobile').toggleClass('in')
)
